<template>
<div>
     <div class="contents navigation-contents">
            <p class="navigation">
                    <i class="icon iconfont icon-yuanquan_huaban1"></i>
                    <span class="nowshow">当前位置：</span>
                    
                    <router-link class="navigation-now" tag="a" :to="{ name: 'index'}">首页</router-link>
                    <i class="icon iconfont icon-youjiantou"></i>
                    <router-link class="navigation-now" tag="a" :to="{ name: 'classIndex',params: { id: 1 }}">产品</router-link>
                    <i class="icon iconfont icon-youjiantou"></i>
                    <span class="navigation-now">{{classname}}</span>

            </p>
       </div>
    <div class="classname">
    {{classname}}
    </div> 
</div>
 
</template>

<script>
export default {
    props:['classname']
}
</script>

<style  scoped>

    .breadcrumb{
        margin-top: 25px;
        font-size: 16px;
    }
    .classname{
        margin-top: 18px;
        margin-bottom: 25px;
        font-size: 24px;
    }
    .navigation .icon-yuanquan_huaban1{
        color: #fbb113;
    }
    .navigation{
        margin-top: 25px;
        float:right;
        display: flex;
        align-items: center;
        font-size: 14px;
    }
    .navigation-contents{
        overflow: hidden;
    }
    .nowshow{
        color: #666;
    }
    .navigation-now{
        color: #888;
    }
    .navigation a:hover{color:#2655ae;text-decoration:underline}
</style>


// WEBPACK FOOTER //
// src/components/goods/GoodsListTitle.vue